export const ORDER_LIST_PAGE_PATH = '/order/list'
